<template>
  <hm-content>
    <div class="table-panel flex flex-between">
      <div>
        <el-button type="primary" size="small" @click="addPage"
          >新增权益页</el-button
        >
      </div>
      <div>
        <el-select
          size="small"
          class="mr20"
          v-model="rightType"
          clearable
          placeholder="请选择权益类型"
        >
          <el-option label="基础权益" value="basic"></el-option>
          <el-option label="增值权益" value="increase"></el-option>
        </el-select>
        <el-input
          size="small"
          class="mr20"
          clearable
          placeholder="请输入权益名称"
          v-model="rightName"
        ></el-input>
        <el-button size="small" type="primary" @click="search">查询</el-button>
      </div>
    </div>
    <div class="table">
      <el-table
        :data="plusPageList.records"
        style="width: 100%"
        stripe
        size="small"
        border
      >
        <!-- <el-table-column type="selection"></el-table-column> -->
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="权限名称"
          prop="rightName"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="createTime"
          label="创建时间"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="rightType"
          label="权益类型"
        >
          <template v-slot="scope">
            <span v-if="scope.row.rightType === 'basic'">基础权益</span>
            <span v-if="scope.row.rightType === 'increase'">增值权益</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="updateTime"
          label="最后修改时间"
        ></el-table-column>
        <!-- <el-table-column
          header-align="center"
          align="center"
          prop="isCompleted"
          label="是否完整"
        >
          <template slot-scope="scope">
            <span v-show="scope.row.isCompleted === 'yes'" class="success"
              >无缺失</span
            >
            <span v-show="scope.row.isCompleted === 'no'" class="danger"
              >有缺失</span
            >
          </template>
        </el-table-column> -->
        <el-table-column
          label="操作"
          width="150"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-tooltip class="item" content="编辑" placement="top">
                <div class="pointer mr10" @click="edit(scope.row)">
                  <span class="hmicon icon-bianji blue"></span>
                </div>
              </el-tooltip>
              <el-tooltip class="item" content="删除" placement="top">
                <div class="pointer" @click="remove(scope.row)">
                  <span class="hmicon icon-shanchu primary"></span>
                </div>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="plusPageList.total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      width="70%"
      :before-close="handleClose"
      :visible.sync="dialogVisible"
      @close="closeDialog"
    >
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        label-width="200px"
      >
        <el-form-item label="权益类型">
          <el-radio-group v-model="ruleForm.rightType">
            <el-radio label="basic">基础权益</el-radio>
            <el-radio label="increase">增值权益</el-radio>
          </el-radio-group>
          <div class="form-tip">
            基础权益主要是配置页面样式和权益实现后的页面跳转
          </div>
        </el-form-item>
        <el-form-item label="权益名称" prop="rightName">
          <el-input
            size="small"
            clearable
            class="mr10 ipt"
            style="width:270px"
            v-model.trim="ruleForm.rightName"
            placeholder="请输入权益名称，建议6字内"
          ></el-input>
        </el-form-item>
        <el-form-item label="权益描述" prop="rightExplain">
          <el-input
            size="small"
            clearable
            class="mr10 ipt"
            style="width:270px"
            v-model.trim="ruleForm.rightExplain"
            placeholder="请输入权益描述，建议10字内"
          ></el-input>
        </el-form-item>
        <el-form-item label="权益图标" prop="iconUrl">
          <my-upload
            field="file"
            :headers="{ 'X-Access-Token': $token }"
            :params="{ fileDir: 'goodsCenter' }"
            @crop-success="cropSuccess"
            @crop-upload-success="cropUploadSuccess"
            @crop-upload-fail="cropUploadFail"
            v-model="show"
            noCircle
            noSquare
            :width="200"
            :height="200"
            :url="$uploadUrl"
            img-format="png"
          ></my-upload>
          <el-button
            type="primary"
            size="small"
            v-show="!ruleForm.iconUrl"
            @click="toggleShow"
            >点击上传</el-button
          >
          <span class="form-tip">（图标建议尺寸200x200像素）</span>
          <div class="priview" v-if="ruleForm.iconUrl">
            <img :src="ruleForm.iconUrl" alt="主图" />
            <div class="opreat-wrapper flex item-center flex-center">
              <el-button type="text" @click="handleRemove">删除</el-button>
            </div>
          </div>
        </el-form-item>
        <!-- <el-form-item label="权益简介图" prop="showUrl">
          <my-upload
            field="file"
            :headers="{ 'X-Access-Token': $token }"
            :params="{ fileDir: 'goodsCenter' }"
            @crop-success="cropSuccess"
            @crop-upload-success="cropUploadSuccess"
            @crop-upload-fail="cropUploadFail"
            v-model="showIntro"
            noCircle
            noSquare
            :width="750"
            :height="360"
            :url="$uploadUrl"
            img-format="png"
          ></my-upload>
          <el-button
            type="primary"
            size="small"
            v-show="!ruleForm.showUrl"
            @click="toggleShowIntro"
            >点击上传</el-button
          >
          <span class="form-tip">（图标建议尺寸750x360像素）</span>
          <div class="priviewIntro" v-if="ruleForm.showUrl">
            <img :src="ruleForm.showUrl" alt="主图" />
            <div class="opreat-wrapper flex item-center flex-center">
              <el-button type="text" @click="handleRemoveIntro">删除</el-button>
            </div>
          </div>
        </el-form-item> -->
        <el-form-item label="权益详情图" prop="detailUrl">
          <!-- <my-upload
            field="file"
            :headers="{ 'X-Access-Token': $token }"
            :params="{ fileDir: 'goodsCenter' }"
            @crop-success="cropSuccess"
            @crop-upload-success="cropUploadSuccess"
            @crop-upload-fail="cropUploadFail"
            v-model="showDetails"
            noCircle
            noSquare
            :width="750"
            :height="1334"
            :url="$uploadUrl"
            img-format="png"
          ></my-upload>
          <el-button
            type="primary"
            size="small"
            v-show="!ruleForm.detailUrl"
            @click="toggleShowDetails"
            >点击上传</el-button
          > -->
          <div v-if="ruleForm.detailUrl" class="flex">
            <div class="mr10  priview-detailUrl">
              <el-image
                class="img"
                :src="ruleForm.detailUrl"
                alt="logo"
                :preview-src-list="[ruleForm.detailUrl]"
              />
              <div class="opreat-wrapper flex item-center flex-center">
                <el-button type="text" @click="handleRemoveDetails('gameBgp')"
                  >删除</el-button
                >
              </div>
            </div>
            <div class="el-upload__tip">
              <span class="mr">
                上传图片注意：
                <br />1.建议图片尺寸为550x750像素的png图
                <br />2.图片格式：png、jpg、bmp 
                <br />3.图片大小尽量在300K以内
                <br />4.点击图片可预览
              </span>
            </div>
          </div>
          <el-upload
            v-else
            class="upload flex"
            ref="upload"
            :data="{ fileDir: 'mall' }"
            :headers="{ 'X-Access-Token': $token }"
            :action="$uploadUrl"
            :onError="uploadError"
            :onSuccess="cropUploadSuccessNew"
            :beforeUpload="beforeAvatarUpload"
            :onProgress="uploading"
          >
            <div class="flex upload-upload-btn">
              <div class="btn flex flex-column flex-center open-file">
                <div class="add-wrapper">
                  <span
                    class="hmicon icon-hao pointer"
                    style="margin-right: 0px"
                  ></span>
                </div>
                <span class="gray">上传权益详情图</span>
              </div>
            </div>
            <div class="el-upload__tip" slot="tip">
              <span class="mr">
                上传图片注意：
                <br />1.建议图片尺寸为550x750像素的png图
                <br />2.图片格式：png、jpg、bmp 
                <br />3.图片大小尽量在300K以内
                <br />4.点击图片可预览
              </span>
            </div>
          </el-upload>
          <!-- <span class="form-tip">（图标建议尺寸750x1334像素）</span>
          <div class="priviewDetails" v-if="ruleForm.detailUrl">
            <img :src="ruleForm.detailUrl" alt="权益详情图" />
            <div class="opreat-wrapper flex item-center flex-center">
              <el-button type="text" @click="handleRemoveDetails"
                >删除</el-button
              >
            </div>
          </div> -->
        </el-form-item>
        <el-form-item label="跳转链接" prop="linkType">
          <el-radio-group
            v-model="ruleForm.linkType"
            @change="openGoodsSelectSingle"
          >
            <el-radio label="page">页面</el-radio>
            <el-radio label="goods">商品</el-radio>
          </el-radio-group>
          <div
            class="flex item-center"
            v-if="ruleForm.linkType === 'page' && !ruleForm.spuName"
          >
            <span class="mr10">链接</span>
            <el-select
              size="small"
              clearable
              placeholder="选择页面"
              v-model="ruleForm.linkUrl"
              filterable
              @change="selectGroup"
            >
              <el-option
                v-for="(item, i) in microShopRouteList"
                :key="i"
                :label="item.hrefName"
                :value="item.hrefAddress"
              ></el-option>
            </el-select>
          </div>
          <div
            class="flex item-center"
            v-if="ruleForm.linkType === 'goods' && ruleForm.spuName"
          >
            <span class="mr10">商品</span>
            <el-tag closable @close="handleCloseSingle" type="success">{{
              ruleForm.spuName
            }}</el-tag>
          </div>
          <div
            v-if="ruleForm.linkType === 'page' && ruleForm.groupGoods.groupName"
          >
            <span class="mr10">分组</span>
            <el-tag closable @close="handleCloseGoods" type="success">
              {{ ruleForm.groupGoods.groupName }}
            </el-tag>
          </div>
        </el-form-item>
        <el-form-item label="权益统计券类型" prop="couponList">
          <div>
          <el-button size="small" type="primary" @click="showCouponList"
            >添加统计券</el-button
          >
          </div>
          <div class="flex flex-wrap mt10">
          <el-tag closable @close="handleCloseCoupon(i)" type="success" class="mr10" v-for="(v,i) in ruleForm.couponList" :key="i">
            {{ v.name }}
          </el-tag>
          </div>
        </el-form-item>  
        <span v-show="rightType=='increase' || ruleForm.rightType=='increase'">
          <el-form-item>
            <div class="quan-wrap">
              <div class="_title">累计发券设置</div>
              <div class="content">
                <div class="content-header">统计商品 <el-button @click="showTransfer" type="primary" plain>添加商品</el-button></div>
                <el-table :data="goodsTable" stripe style="width: 50%">
                  <el-table-column label="商品名称" prop="valueName" align="center"></el-table-column>
                  <el-table-column label="商品货号" prop="value" align="center"></el-table-column>
                  <el-table-column label="商品条码" prop="value" align="center"></el-table-column>
                </el-table>
              </div>
            </div>
          </el-form-item>


        <el-form-item label="选择门店">
          <shop-picker
            :available-shops="shopList.records"
            :selected-shops.sync="selectedShops"
            @change="handleShopPickerChange"
          />
        </el-form-item>
          


          
          
          <el-form-item>
            <div class="flex input-wrapper"><span class="mr60">每购物达<el-input-number size="small" v-model="ruleForm.storePlusRightPageCouponSendRelModel.accumulateNumLimit" :controls="false"></el-input-number>听，发放</span>单人最多获得<el-input-number size="small" v-model="ruleForm.storePlusRightPageCouponSendRelModel.singleNumLimit" :controls="false"></el-input-number>张</div>
            <div><span class="mr10">关联发放券</span><el-select v-model="ruleForm.storePlusRightPageCouponSendRelModel.couponSendId" size="small">
              <el-option v-for="item in couponList" :key="item.couponSendId" :label="item.name" :value="item.couponSendId"></el-option></el-select></div>
          </el-form-item>
        </span>
      </el-form>
      <div class="btn-wrapper flex flex-center">
        <el-button size="small" type="primary" @click="confirm('ruleForm')"
          >确 定</el-button
        >
        <el-button size="small" @click="canel">取 消</el-button>
      </div>
    </el-dialog>
    <hm-filter-micro-shop-goods
      type="microShop"
      :visible="dialogVisibleGoods"
      radio
      @setLink="setLink"
      @close="dialogVisibleGoods = false"
    ></hm-filter-micro-shop-goods>
    <hm-filter-group-goods
      @saveGroupGoods="saveGroupGoods"
      @close="groupGoodsVisible = false"
      :visible="groupGoodsVisible"
    ></hm-filter-group-goods>
    <hm-coupon-rule-list
      :visible="selectCouponVisible"
      @saveCoupon="saveCoupon"
      @close="closeCoupon"
    ></hm-coupon-rule-list>

    
    <el-dialog
      title="添加商品"
      :close-on-click-modal="false"
      :visible.sync="dialogGoodsVisible"
      width="1200px"
    >
      <hm-transfer
        ref="ruleTransfer"
        onlySelectGoods
        :showAttribute="parentId === 'FullDelivery'"
        :showMustDelivery="showMustDelivery"
        :leftOption="leftRules"
        :showBarcode="showBarcode"
      ></hm-transfer>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="saveSelectedGoods" size="small" type="primary"
          >保存</el-button
        >
        <el-button @click="dialogGoodsVisible = false" size="small">关闭</el-button>
      </span>
    </el-dialog>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
import HmFilterMicroShopGoods from "@/components/HmFilterMicroShopGoods";
import myUpload from "vue-image-crop-upload";
import HmFilterGroupGoods from "@/components/HmFilterGroupGoods";
import HmCouponRuleList from "@/components/HmCouponRuleList";
import HmTransfer from "@/components/HmTransfer";
import ShopPicker from "@/components/shop-picker";
import {
  arrayUnique2,
} from "@/utils/utils";
import { getLoginUser } from "@/utils/auth";
export default {
  components: { myUpload, HmFilterMicroShopGoods, HmFilterGroupGoods, HmCouponRuleList, HmTransfer, ShopPicker },
  data() {
    return {
      parentId: "",
      shopInfo: null,
      showMustDelivery: false,
      showBarcode: true,
      leftRules: [],
      dialogGoodsVisible: false,
      searchCondition: {},
      groupGoodsVisible: false,
      currentPage: 1,
      pageSize: 10,
      title: "",
      rightType: "",
      rightName: "",
      dialogVisible: false,
      dialogVisibleGoods: false,
      ruleForm: {
        rightType: "basic",
        rightExplain: "",
        rightName: "",
        spuName: "",
        iconUrl: "",
        showUrl: "",
        detailUrl: "",
        linkType: "",
        linkUrl: "",
        groupName: "",
        plusRightId: "",
        groupGoods: {},
        couponList: [],
        plusRightPageCouponRelModelList: [],
        shopList: [],
        storePlusRightPageCouponSendRelModel:{
          accumulateNumLimit: undefined,
          singleNumLimit: undefined,
          couponSendId: "",
        }
      },
      rules: {
        rightName: [
          {
            required: true,
            message: "请输入权益名称",
            trigger: "change"
          },
          { max: 6, message: "长度在6个字符内", trigger: "change" }
        ],
        rightExplain: [
          {
            required: true,
            message: "请输入权益描述，建议10字内",
            trigger: "change"
          },
          { max: 10, message: "长度在10个字符内", trigger: "change" }
        ],
        iconUrl: [
          { required: true, message: "请选择权益图标", trigger: "change" }
        ],
        showUrl: [
          { required: false, message: "请选择权益简介图", trigger: "change" }
        ],
        detailUrl: [
          { required: true, message: "请选择权益详情图", trigger: "change" }
        ]
      },
      show: false,
      showIntro: false,
      showDetails: false,
      selectCouponVisible: false,
      goodsTable: [],
      couponList: [],
      selectedShops: []
    };
  },
  computed: mapGetters(["shopList", "plusPageList", "microShopRouteList"]),
  watch: {
    "plusPageList.total": {
      handler(val) {
        if (
          val == (this.currentPage - 1) * this.pageSize &&
          this.pageTotal != 0
        ) {
          this.currentPage -= 1;
          // this.queryList();
        }
      },
      deep: true
    }
  },
  created() {
    this.$store.dispatch("queryShopList", { pageNo: 1, pageSize: 99999 });
    this.$store.dispatch("queryMicroShopList", {
      pageType: "page"
    });
  },
  mounted() {
    this.queryList();
    this.findCouponSendByEvent()
  },
  methods: {
    handleShopPickerChange(shops) {
      this.selectedShops = shops;
    },
    closeDialog() {
      this.goodsTable = []
      this.selectedShops = []
      this.ruleForm = {
        rightType: "basic",
        rightExplain: "",
        rightName: "",
        spuName: "",
        iconUrl: "",
        showUrl: "",
        detailUrl: "",
        linkType: "",
        linkUrl: "",
        groupName: "",
        plusRightId: "",
        groupGoods: {},
        couponList: [],
        plusRightPageCouponRelModelList: [],
        shopList: [],
        storePlusRightPageCouponSendRelModel:{
          accumulateNumLimit: undefined,
          singleNumLimit: undefined,
          couponSendId: "",
        }
      }
    },
    findCouponSendByEvent() {
      this.$store.dispatch("findCouponSendByEvent", {pageNo: 1,pageSize: 9999}).then(res => {
        this.couponList = res.result
      })
    },
    showTransfer() {
      this.dialogGoodsVisible = true;
      this.showMustDelivery = true;
      this.$nextTick(() => {
        this.$refs.ruleTransfer.rightChecked = [];
      });
    },
    saveSelectedGoods() {
      let rightChecked = this.$refs.ruleTransfer.rightChecked;
      this.goodsTable = rightChecked.map(item => {
        return {
          type: 'goods',
          value: item.goodsSn,
          valueName: item.goodsName
        }
      });
      console.log('rightCheckedrightChecked', rightChecked);
      this.dialogGoodsVisible = false;
      this.$refs.ruleTransfer.rightChecked = [];
      this.$refs.ruleTransfer.rightData = [];
    },
    cropUploadSuccessNew(jsonData) {
      if (jsonData.code === 0) {
        this.ruleForm.detailUrl = jsonData.result;
        // setTimeout(() => {
        //   this.show = false;
        // }, 0);
      }
    },
    // 上传错误
    uploadError() {
      this.$message({
        message: "上传失败，请重试!",
        type: "warning"
      });
      //   this.isSaving = false;
    },
    // 上传前对文件的大小的判断
    beforeAvatarUpload(file) {
      const extension =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "jpg";
      const extension2 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
        "jpeg";
      const extension3 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "png";
      const extension4 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "bmp";
      // file.size单位为b，除以1024得到kb
      // const limitSize = file.size / 1024 <= 100;
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: "上传模板只能是 jpg、jpeg、png、bmp格式!",
          type: "warning"
        });
      }
      // if (!limitSize) {
      //   this.$message({
      //     message: "上传模板大小不能超过 100k!",
      //     type: "warning"
      //   });
      // }
      return extension || extension2 || extension3 || extension4;
    },
    // 正在上传
    uploading() {
      //   this.isSaving = true;
    },
    handleCloseSingle() {
      this.ruleForm.spuName = "";
      this.ruleForm.linkUrl = "";
      this.ruleForm.linkType = "page";
    },
    selectGroup(e) {
      if (e === "groupGoods") {
        this.groupGoodsVisible = true;
      } else {
        this.ruleForm.groupGoods = {};
      }
    },
    saveGroupGoods(row) {
      this.groupGoodsVisible = false;
      this.ruleForm.groupGoods = row;
      this.ruleForm.linkUrl = `/pages/product/list?groupId=${row.groupId}`;
      this.ruleForm.spuName = row.groupName;
    },
    setLink(row) {
      this.ruleForm.linkUrl = `/pages/product/product?wxshopSpuId=${row.wxshopSpuId}`;
      this.ruleForm.spuName = row.wxshopSpuName;
      this.dialogVisibleGoods = false;
    },
    queryList() {
      return this.$store.dispatch("plusPageList", {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        rightName: this.rightName,
        rightType: this.rightType
      });
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    handleCloseGoods() {
      this.ruleForm.groupName = "";
      this.ruleForm.linkUrl = "";
      this.ruleForm.groupGoods = {};
      this.ruleForm.spuName = "";
    },
    openGoodsSelectSingle() {
      if (this.ruleForm.linkType === "goods") {
        this.dialogVisibleGoods = true;
        this.isRadio = true;
        // 为-1表示设置单个
        this.currentLinkIndex = -1;
        this.ruleForm.groupGoods = {};
      }
      this.ruleForm.spuName = "";
      this.ruleForm.linkUrl = "";
      this.ruleForm.groupName = "";
      this.ruleForm.groupId = "";
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    edit(row) {
      console.log('--row--', row);
      this.title = "编辑权益页";
      if (row.storePlusRightPageConfigRelModelList) {
        this.goodsTable = row.storePlusRightPageConfigRelModelList.filter(item => item.type==='goods');
        const shopList = row.storePlusRightPageConfigRelModelList.filter(item => item.type==='shop');
        this.selectedShops = shopList.map(item => ({
          shopId: item.value,
          shopName: item.valueName
        }));
      }
      this.dialogVisible = true;
      for (let key in row) {
        if (this.ruleForm.hasOwnProperty(key) && row[key]) {
          this.ruleForm[key] = row[key];
          if (this.ruleForm.linkUrl.indexOf("groupId") > -1) {
            this.ruleForm.groupGoods = {
              groupId: this.ruleForm.linkUrl.split("?groupId=")[1],
              groupName: this.ruleForm.spuName
            };
          }
        }
      }
      console.log('this.ruleForm', this.ruleForm);
      this.queryPlusRightAdCouponList(row);
    },
    remove(row) {
      this.$confirm(" 删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let params = {
          plusRightId: row.plusRightId,
          delFlag: "1"
        };
        this.$store.dispatch("addPlusPageList", params).then(res => {
          if (res.code === "0") {
            this.$message({
              message: "操作成功",
              type: "success"
            });
            this.queryList();
          }
        });
      });
    },
    addPage() {
      this.dialogVisible = true;
      this.title = "新增权益页";
      this.ruleForm.spuName = "";
      this.ruleForm.groupGoods = {};
      this.ruleForm.linkUrl = "";
    },
    toggleShow() {
      this.show = !this.show;
    },
    toggleShowIntro() {
      this.showIntro = !this.showIntro;
    },
    toggleShowDetails() {
      this.showDetails = !this.showDetails;
    },
    confirm(formName) {
      console.log('--this.ruleForm--', this.ruleForm);
      // 使用 selectedShops 生成门店列表
      const shopList = this.selectedShops.map(item => ({
        value: item.shopId || item.id,
        valueName: item.shopName || item.name,
        type: "shop"
      }));
      let storePlusRightPageConfigRelModelList = this.goodsTable.concat(shopList)
      console.log(storePlusRightPageConfigRelModelList);

      if(this.goodsTable && this.goodsTable.length) {
        if(!this.ruleForm.storePlusRightPageCouponSendRelModel.accumulateNumLimit) {
          return this.$message.warning('请输入到达发券数量')
        }
        if(!this.ruleForm.storePlusRightPageCouponSendRelModel.singleNumLimit) {
          return this.$message.warning('请输入发放券数量')
        }
        if(!this.ruleForm.storePlusRightPageCouponSendRelModel.couponSendId) {
          return this.$message.warning('请选择发放券')
        }
        // storePlusRightPageCouponSendRelModel:{
        //   accumulateNumLimit: undefined,
        //   singleNumLimit: undefined,
        //   couponSendId: "",
        // }
      }
      this.$refs[formName].validate(valid => {
        if (valid) {
          let param = {...this.ruleForm, storePlusRightPageConfigRelModelList}
          this.$store.dispatch("addPlusPageList", param).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              setTimeout(() => {
                this.resetRuleForm();
              }, 0);
              this.dialogVisible = false;
              this.queryList();
            }
          });
        } else {
          return false;
        }
      });
    },
    canel() {
      this.dialogVisible = false;
      setTimeout(() => {
        this.resetRuleForm();
      }, 0);
    },
    handleClose(done) {
      done();
      setTimeout(() => {
        this.resetRuleForm();
      }, 0);
    },
    resetRuleForm() {
      this.$refs.ruleForm.resetFields();
      this.ruleForm.rightExplain = "";
      this.ruleForm.rightName = "";
      this.ruleForm.spuName = "";
      this.ruleForm.iconUrl = "";
      this.ruleForm.showUrl = "";
      this.ruleForm.detailUrl = "";
      this.ruleForm.linkType = "";
      this.ruleForm.linkUrl = "";
      this.ruleForm.groupName = "";
      this.ruleForm.plusRightId = "";
      this.ruleForm.couponList = [];
      this.ruleForm.plusRightPageCouponRelModelList = [];
    },
    // 移除上传文件
    handleRemove() {
      this.ruleForm.iconUrl = "";
    },
    // 移除上传文件
    handleRemoveIntro() {
      this.ruleForm.showUrl = "";
    },
    // 移除上传文件
    handleRemoveDetails() {
      this.ruleForm.detailUrl = "";
    },
    cropSuccess() {},
    /**
     * upload success
     *
     * [param] jsonData   服务器返回数据，已进行json转码
     * [param] field
     */
    cropUploadSuccess(jsonData) {
      if (this.show) {
        this.ruleForm.iconUrl = jsonData.result;
      } else if (this.showIntro) {
        this.ruleForm.showUrl = jsonData.result;
      } else if (this.showDetails) {
        this.ruleForm.detailUrl = jsonData.result;
      }
    },
    cropUploadFail() {},
    handleCloseCoupon(index){
      this.ruleForm.couponList.splice(index, 1);
      this.ruleForm.plusRightPageCouponRelModelList.splice(index, 1);
    },
    showCouponList(){
      this.selectCouponVisible = true;
    },
    saveCoupon(data) {
      this.ruleForm.couponList = data;
      this.ruleForm.couponList = this.ruleForm.couponList.filter(v => v.ruleId);
      this.ruleForm.plusRightPageCouponRelModelList = this.ruleForm.couponList.map(v => v.ruleId);
      console.log("this.ruleForm.couponList:",this.ruleForm.couponList);
      console.log("this.ruleForm.plusRightPageCouponRelModelList:",this.ruleForm.plusRightPageCouponRelModelList);
      this.selectCouponVisible = false;
    },
    closeCoupon() {
      this.selectCouponVisible = false;
    },
    async queryPlusRightAdCouponList(row){
      const params={
        plusRightId: row.plusRightId
      }
      const { code, result } = await this.$store.dispatch("queryPlusRightAdCouponList", params)
      if(code === '0'){
        this.ruleForm.couponList = result;
        this.ruleForm.couponList.forEach(v=>{
          v.ruleId = v.couponRuleId;
          v.name = v.couponRuleName;
        })
        this.ruleForm.couponList = this.ruleForm.couponList.filter(v => v.ruleId);
        this.ruleForm.plusRightPageCouponRelModelList = this.ruleForm.couponList.map(v => v.ruleId);
        this.ruleForm = JSON.parse(JSON.stringify(this.ruleForm));
      }
    },
  }
};
</script>
<style lang="scss" scoped>
.priview {
  position: relative;
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
.priviewIntro {
  position: relative;
  width: 375px;
  height: 180px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
.priviewDetails {
  position: relative;
  width: 375px;
  height: 667px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}

.upload-upload-btn {
  .tips {
    color: #999;
    font-size: 12px;
    line-height: 20px;
  }

  .btn {
    border: 1px solid #ddd;
    text-align: center;
    margin-left: 0;
    // padding: 10px;
    margin-right: 10px;
    width: 270px;
    height: 450px;
    cursor: pointer;
    .add-wrapper {
      width: 30px;
      height: 30px;
      line-height: 30px;
      background: #e50065;
      color: #fff;
      text-align: center;
      border-radius: 50%;
      margin: 0 auto;
      span {
        font-size: 12px;
      }
      cursor: pointer;
      .hmicon {
        font-size: 14px;
      }
    }
  }
}

.priview-detailUrl {
  position: relative;
  width: 270px;
  height: 450px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  margin: 10px;
  .img {
    width: 100%;
    height: 100%;
  }
  img {
    width: 100%;
    // height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    // bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
.quan-wrap {
  ._title {
    height: 22px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: #222222;
    line-height: 19px;
    text-align: left;
    position: relative;
    margin-bottom: 20px;
    &::before {
      content: "";
        position: absolute;
        left: -10px;
        top: 0;
        bottom: 0;
        margin: auto;
        background: #e50065;
        width: 3px;
        height: 14px;
        border-radius: 2px 0px 2px 0px;
      }
    }
  .content {
    .content-header {
      display: flex;
      align-items: center;
      font-family: PingFang HK, PingFang HK;
      font-weight: 500;
      font-size: 14px;
      color: #222222;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-bottom: 20px;
      .el-button {
        margin-left: 20px;
      }
    }
  }
}

.input-wrapper {
  margin-bottom: 10px;
  /deep/ .el-input-number {
    margin: 0 10px;
  }
  /deep/ .el-input {
    width: 100%;
  }
  /deep/ .el-input__inner {
    text-align: left;
  }
  .mr60 {
    margin-right: 60px;
  }
}
</style>
